import Input from "components/inputs";
import { useTranslation } from "react-i18next";

export default function BankRuls({ value, onChangeRules }) {
  const { t } = useTranslation();
  const rules = (
    <div className="caption-12px-demibold text-gray-4">
      {t("card-page.video-capture")}
    </div>
  );

  return (
    <div className="mb-3 ">
      <Input
        checkboxContent={rules}
        name="rules"
        type="checkbox"
        value={value}
        onChange={onChangeRules}
      />
    </div>
  );
}
